import React, { useState } from 'react';
import clsx from 'clsx';
import { v4 as uuidv4 } from 'uuid';
import { BaseTypography, LinearTabs } from 'src/components/common';
import { makeStyles } from '@material-ui/core/styles';
import { IGuestInfo } from 'src/api/base/Guest/types';

enum TabValues {
  Images,
  EmbedInterviews,
}

const tabs = [
  { label: 'Images', value: TabValues.Images },
  { label: 'Embed Interviews', value: TabValues.EmbedInterviews },
];

const getListOfMedia = (width: string) => {
  return {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, ${width})`,
    gridGap: '20px',
  };
};
const useStyles = makeStyles((theme) => ({
  body: {
    margin: '20px 0',
  },
  listOfImages: getListOfMedia('190px'),
  listOfVideos: getListOfMedia('250px'),
  listOfLinks: {
    margin: '20px 0',
    display: 'grid',
    gridGap: '10px',
  },
  link: {
    color: theme.palette.primary.main,
  },
}));

type PMediaSection = {
  videos: IGuestInfo['videos'];
  images: IGuestInfo['images'];
  className?: any;
};
const checkIsYoutubeLink = (link: string) => link.includes('youtube.com/watch');

export const MediaSection: React.FC<PMediaSection> = (props) => {
  const { videos, images, className } = props;
  const [currentTab, setCurrentTab] = useState(TabValues.Images);
  const classes = useStyles();
  const youtubeVideos = videos.filter(
    (video) => video && checkIsYoutubeLink(video),
  );

  const otherVideos = videos.filter(
    (video) => video && !checkIsYoutubeLink(video),
  );

  return (
    <div className={clsx(className)}>
      <LinearTabs tabs={tabs} value={currentTab} onTabClick={setCurrentTab} />

      <div className={classes.body}>
        {currentTab === TabValues.Images && (
          <div className={classes.listOfImages}>
            {images.map((image) => {
              return (
                <a href={image.image} target="_blank" rel="noreferrer">
                  <img src={image.image} alt="img" key={image.id} />
                </a>
              );
            })}
          </div>
        )}

        {currentTab === TabValues.EmbedInterviews && (
          <div>
            <div className={classes.listOfVideos}>
              {youtubeVideos.map((video) => {
                const { searchParams } = new URL(video);
                const videoKey = searchParams.get('v');
                const embedLink = videoKey
                  ? `https://www.youtube.com/embed/${videoKey}`
                  : video;
                return (
                  // eslint-disable-next-line jsx-a11y/media-has-caption
                  <iframe
                    key={videoKey}
                    title="YT"
                    width="100%"
                    height="180px"
                    src={embedLink}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  />
                );
              })}
            </div>
            <div className={classes.listOfLinks}>
              {otherVideos.map((video) => {
                return (
                  <BaseTypography variant="tag" key={uuidv4()}>
                    <a
                      href={video}
                      target="_blank"
                      rel="noreferrer"
                      className={classes.link}>
                      {video}
                    </a>
                  </BaseTypography>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
